import { AccountLayout } from "../../layouts";
import { UserAuthentication } from "../../components/UserAuthentication";

export const UserAuthenticationPage = () => {
  return <AccountLayout contents={<UserAuthentication />} />;
};
